import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	searchAcrossProducts: {
		id: 'search_dialog_search_across_products',
		defaultMessage: 'Search across products',
		description: 'Label for link to redirect users to search page',
	},
});
